import React, { JSX, useEffect, useState } from "react";
import { ColumnConfig, TextAlignment } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";

interface BlurredProviderAffiliationsFlyoutTableToppings {
  key: string;
  name: string;
  npi: string;
  type: string;
}

const BlurredProviderAffiliationsFlyoutTable = (): JSX.Element => {
  const [providerAffiliationsFlyoutTableToppings, setProviderAffiliationsFlyoutTableToppings] = useState<BlurredProviderAffiliationsFlyoutTableToppings[]>([]);

  useEffect(() => {
    buildFakeData();
  }, []);

  const columnConfig: ColumnConfig = {
    name: {
      alignment: TextAlignment.Left,
      displayText: "Name",
      noSort: true,
      testId: "name",
    },
    npi: {
      alignment: TextAlignment.Left,
      displayText: "NPI",
      noSort: true,
      testId: "npi",
    },
    type: {
      alignment: TextAlignment.Left,
      displayText: "Type",
      noSort: true,
      testId: "type",
    },
  };

  const buildFakeData = (): void => {
    const waffleToppings: BlurredProviderAffiliationsFlyoutTableToppings[] = [1, 2].map((x) => {
      /* oxlint-disable sort-keys */
      return {
        key: x.toString(),
        name: `Quest Affiliations ${x}`,
        type: `Type ${x}`,
        npi: "123456789",
      };
      /* oxlint-enable sort-keys */
    });

    setProviderAffiliationsFlyoutTableToppings(waffleToppings);
  }

  return (
    <React.Fragment>
      <div className="affiliations-blur-container">
        <div className="affiliations-table-container affiliations-blur">
          <h6 className="mb-2">Professional Affiliation (Contract Entity)</h6>
          <Waffles<BlurredProviderAffiliationsFlyoutTableToppings>
            columns={columnConfig}
            data={providerAffiliationsFlyoutTableToppings}
            fullWidth={true}
            testId="benchmarking-dashboard__dashboard-details--blurred-affiliations-flyout-table-1"
          />
          <h6 className="mt-4 mb-2">Institutional Affiliation (Admitting Privileges)</h6>
          <Waffles<BlurredProviderAffiliationsFlyoutTableToppings>
            columns={columnConfig}
            data={providerAffiliationsFlyoutTableToppings}
            fullWidth={true}
            testId="benchmarking-dashboard__dashboard-details--blurred-affiliations-flyout-table-2"
          />
        </div>

        <div className="affiliations-blur-text">
          Affiliation Insights License Required to View This Information
        </div>
      </div>
    </React.Fragment>
  )
}

export default BlurredProviderAffiliationsFlyoutTable;
